import * as React from 'react';
import styled from 'styled-components';
// import { ILdsContactUsData } from '../lds-contact-us.data';

interface ContactTableProps {
    defaultCounty: any;
    selectedCountry: any;
    resources: any;
}

export const ContactTable: React.FC<ContactTableProps> = ({ defaultCounty, selectedCountry, resources }) => {
    const StyledTable = styled.div`
        text-align: left;
        width: 100%;
        display: flex;
        flex-direction: row;

        @media (max-width: 750px) {
            flex-direction: column;
            width: 95%;
            justify-content: space-around;
        }
    `;

    const TableWrapper = styled.div`
        display: flex;
        justify-content: space-around;
        width: 100%;
    `;

    const TableHeader = styled.div`
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #d0d3d3;
        height: 40px;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #212225;
    `;
    const TableData = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #d0d3d3;
        height: 50px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px
        line-height: 20px;
        color: #212225;
        width: 100%;
    `;

    const TableRow = styled.div`
        display: flex;
        flex-direction: column;
        width: 100%;

        @media (max-width: 750px) {
            margin-bottom: 48.5px;
        }
    `;

    return (
        <TableWrapper>
            {JSON.stringify(selectedCountry) === '{}' || selectedCountry.EXTCODEVALUE === '' ? (
                <StyledTable>
                    <TableRow>
                        <TableHeader>{resources.tableHeaderCountry}</TableHeader>
                        <TableData>{defaultCounty.CountryName}</TableData>
                    </TableRow>
                    <TableRow>
                        <TableHeader>{resources.tableHeaderTelephone}</TableHeader>
                        <TableData>{defaultCounty.EXTCODEVALUE}</TableData>
                    </TableRow>
                </StyledTable>
            ) : (
                <StyledTable>
                    <TableRow>
                        <TableHeader>{resources.tableHeaderCountry}</TableHeader>
                        {/*@ts-ignore*/}
                        <TableData>{selectedCountry.CountryName}</TableData>
                    </TableRow>
                    <TableRow>
                        <TableHeader>{resources.tableHeaderTelephone}</TableHeader>
                        {/*@ts-ignore*/}
                        <TableData>{selectedCountry.EXTCODEVALUE}</TableData>
                    </TableRow>
                </StyledTable>
            )}
        </TableWrapper>
    );
};
